import { remoteUrl, urlWithParams } from "../../helpers/UrlHelpers";

const ROBLOX_URL = process.env.REACT_APP_ROBLOX_URL;
const DEFAULT_PARAMS  = { order_by: 'id', order: 'desc' };

function skinPath(this: any, id: number) {
  return `/${this.basePath}/skins/${id}`;
}

// Templates
function templatesPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/templates`, params);
}
function templatePath(this: any, id: number) {
  return `/${this.basePath}/templates/${id}`;
}

function templatesPantsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/templates/pants`, params);
}
function templatesTshirtsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/templates/t_shirts`, params);
}
function templatesShirtsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/templates/shirts`, params);
}

// Assets
function assetsPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/assets`, params);
}
function assetsPatternsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/assets/patterns`, params);
}
function assetsAccessoriesPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/assets/accessories`, params);
}


// Content
function contentPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/content`, params);
}
function contentPantsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/content/pants`, params);
}
function contentTshirtsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/content/t_shirts`, params);
}
function contentShirtsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/content/shirts`, params);
}
function contentPostsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/content/posts`, params);
}


// Community
function communityPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/community`, params);
}
function communityPantsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/community/pants`, params);
}
function communityTshirtsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/community/t_shirts`, params);
}
function communityShirtsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/community/shirts`, params);
}
function communityPostsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/community/posts`, params);
}

function usersPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/users`, params);
}
function userPath(this: any, id: number) {
  return `/${this.basePath}/users/${id}`;
}

function commentPath(this: any, comment?: any) {
  const params = { tab: 'comment', go_to_comment: comment.id };
  let targetUrl;

  switch (comment.parent_target_type) {
    case 'Skin':
      targetUrl = skinPath.call(this, comment.parent_target_id);
      break;
    case 'User':
      targetUrl = userPath.call(this, comment.parent_target_id);
      break;
    default:
      targetUrl = '/404';
  }

  return targetUrl ? urlWithParams(targetUrl, params) : null;
}

function reportsPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/reports`, params);
}

const robloxUrls = {
  baseURL:    ROBLOX_URL,
  basePath:   'roblox',
  remoteUrl:  remoteUrl,

  skinPath:               skinPath,

  assetsPath:             assetsPath,
  assetsPatternsPath:     assetsPatternsPath,
  assetsAccessoriesPath:  assetsAccessoriesPath,

  contentPath:            contentPath,
  contentPantsPath:       contentPantsPath,
  contentTshirtsPath:     contentTshirtsPath,
  contentShirtsPath:      contentShirtsPath,
  contentPostsPath:       contentPostsPath,

  templatePath:           templatePath,
  templatesPath:          templatesPath,
  templatesPantsPath:     templatesPantsPath,
  templatesTshirtsPath:   templatesTshirtsPath,
  templatesShirtsPath:    templatesShirtsPath,

  communityPath:          communityPath,
  communityPantsPath:     communityPantsPath,
  communityTshirtsPath:   communityTshirtsPath,
  communityShirtsPath:    communityShirtsPath,
  communityPostsPath:     communityPostsPath,

  usersPath:    usersPath,
  userPath:     userPath,

  commentPath: commentPath,
  reportsPath: reportsPath,
}

export default robloxUrls;
